/**
* jv.candidate.details.workflow.reject.controller Module
*
* Description
*/
angular.module('jv.candidate.details.workflow.reject.controller', [])
    .controller('jvCandidateDetailsWorkflowRejectController', ['$scope', '$routeParams', 'candidates', 'findDefaultTemplate',
        function($scope, $routeParams, candidates, findDefaultTemplate){
            $scope.isNewJQuery = parseFloat(jQuery.fn.jquery) > 1.7;
            $scope.$watch('reject.template', function(newVal) {
                if(angular.isDefined(newVal) && angular.isDefined($scope.$eval('rejectInfo.rejectTemplates'))) {
                    $scope.reject.subject = $scope.reject.message = '';
                    angular.forEach($scope.rejectInfo.rejectTemplates, function(template) {
                        if(newVal ===  template.EId) {
                            $scope.reject.subject = template.subject;
                            $scope.reject.message = template.body;
                        }
                    });
                }
            });

            $scope.$watch('rejectInfo.rejectTemplates', function(newVal) {
                $scope.$parent.reject = angular.extend({}, $scope.$parent.reject, findDefaultTemplate(newVal));
            });

            $scope.$watch('reject.to', function(newVal) {
                if(angular.isDefined(newVal) && angular.isDefined($scope.rejectInfo)) {
                    if (newVal === $scope.$eval('rejectInfo.agency.EId')) {
                        $scope.rejectInfo.rejectTemplates = $scope.rejectInfo.agencyRejectTemplates;
                    } else if (newVal === $scope.$eval('appDetails.application.candidate.EId')) {
                        $scope.rejectInfo.rejectTemplates = $scope.rejectInfo.candidateRejectTemplates;
                    }
                }
            });

            $scope.reject.nextPage = function(){
                $scope.allApplications.page++;
                $scope.allApplications.start += 10;
                $scope.allApplications.end = $scope.allApplications.end+10 > $scope.allApplications.list.length ? $scope.allApplications.list.length : $scope.allApplications.end+10;
            };

            $scope.reject.prevPage = function(){
                $scope.allApplications.page--;
                $scope.allApplications.start -= 10;
                $scope.allApplications.end -= 10;
            };

            $scope.reject.hasNext = function(){
                if($scope.allApplications && ($scope.allApplications.page+1)*10 > $scope.allApplications.list.length){
                    return false;
                }
                return true;
            };

            $scope.reject.hasPrev = function(){
                if($scope.allApplications && $scope.allApplications.page !== 0){
                    return true;
                }
                return false;
            };

            $scope.rejectCandidate = function(){
                $scope.reject.checkDisposition = false;
                $scope.reject.checkMessage = false;
                $scope.reject.checkSubject = false;
                $scope.flags.loading=true;
                var data = {
                    dispositionId : $scope.reject.disposition || false,
                    sendRejectionEmail : $scope.reject.sendEmail || false,
                    rejectFromAllApplications : $scope.reject.rejectAll || false,
                    messageDataItem: {
                        subject : $scope.reject.subject,
                        content : $scope.reject.message
                    }
                };

                var bcc = [];

                if(!$scope.reject.disposition && $scope.rejectInfo.candidateDispositions){
                    $scope.reject.checkDisposition = true;
                    $scope.flags.loading=false;
                    return;
                }

                if(data.sendRejectionEmail && (!data.messageDataItem.subject || (data.messageDataItem.subject && data.messageDataItem.subject.trim().length === 0))){
                    $scope.reject.checkSubject = true;
                    $scope.flags.loading=false;
                    return;
                }

                if($scope.reject.cc){
                    angular.forEach($scope.reject.cc, function(user){
                        bcc.push(user.EId);
                    });
                }

                if (data.sendRejectionEmail) {
                    if(($scope.appDetails.application.agencyApp) && ($scope.reject.to === $scope.appDetails.application.candidate.EId)) {
                        bcc.push($scope.appDetails.application.candidate.EId);
                    }
                }

                data.messageDataItem.bccList = bcc;

                if(data.sendRejectionEmail){
                    if(!$scope.reject.message|| $scope.reject.message.trim() === ''){
                        $scope.reject.checkMessage = true;
                        $scope.flags.loading=false;
                        return;
                    }
                    data.notifyCandidate = $scope.appDetails.application.agencyApp ? ($scope.reject.to === $scope.appDetails.application.candidate.EId? true: false) : true;
                } else{
                    data.notifyCandidate = false;
                }

                candidates.rejectCandidate($routeParams.applicationId, data, function(res){
                    $scope.rejectInfo.show=false;
                    $scope.flags.loading=false;
                    $scope.reject = {};

                    if(res.msgInfo === 200){
                        $scope.showMsg('CANDIDATE_REJECTED');
                        $scope.viewApplications(true);
                        /**
                         * TODO: Try to replace this by $scope.updateWorkflowActions
                         */
                        $scope.getApplicationDetails(true);
                        if($scope.activeTab('workflow')){
                            $scope.getWorkflowSummary();
                        }
                    } else{
                        $scope.showMsg('ERROR');
                    }
                });
            };

            $scope.cancelReject = function(reset){
                $scope.rejectInfo.show = false;
                if(reset){
                    $scope.reject.cc = [];
                    $scope.reject.disposition = '';
                    $scope.reject.status = '';
                }
            };
    }]);